import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusIcon, EyeIcon, PencilIcon } from 'lucide-react';
import { DataTable, Column } from '../components/DataTable';
import { StatusBadge } from '../components/StatusBadge';
// Mock data for fiscal year plans
const mockPlans = [{
  id: 'plan-2025-26',
  fiscalYear: 'FY 2025/26',
  status: 'Draft',
  totalBudget: 625000,
  totalItems: 12,
  createdBy: 'Admin User',
  createdDate: '2025-03-15'
}, {
  id: 'plan-2024-25',
  fiscalYear: 'FY 2024/25',
  status: 'Approved',
  totalBudget: 625000,
  totalItems: 10,
  createdBy: 'Admin User',
  createdDate: '2024-03-10'
}, {
  id: 'plan-2023-24',
  fiscalYear: 'FY 2023/24',
  status: 'Approved',
  totalBudget: 1005000,
  totalItems: 8,
  createdBy: 'Admin User',
  createdDate: '2023-03-08'
}, {
  id: 'plan-2022-23',
  fiscalYear: 'FY 2022/23',
  status: 'Approved',
  totalBudget: 890000,
  totalItems: 9,
  createdBy: 'Admin User',
  createdDate: '2022-03-12'
}];
export function AnnualPlanList() {
  const navigate = useNavigate();
  const columns: Column<any>[] = [{
    key: 'fiscalYear',
    label: 'Fiscal Year',
    render: item => <span className="font-medium text-indigo-600" data-id="element-510">{item.fiscalYear}</span>
  }, {
    key: 'status',
    label: 'Status',
    render: item => <StatusBadge status={item.status} data-id="element-511" />
  }, {
    key: 'totalBudget',
    label: 'Total Allocated',
    render: item => `$${item.totalBudget.toLocaleString()}`
  }, {
    key: 'totalItems',
    label: 'Total Items'
  }, {
    key: 'createdBy',
    label: 'Created By'
  }, {
    key: 'createdDate',
    label: 'Created Date'
  }, {
    key: 'actions',
    label: 'Action',
    render: item => <div className="flex items-center space-x-3" data-id="element-512">
          <button onClick={() => navigate(`/procurement-plan/${item.id}`)} className="text-indigo-600 hover:text-indigo-900 flex items-center text-sm font-medium" data-id="element-513">
            <EyeIcon className="h-4 w-4 mr-1" data-id="element-514" /> View
          </button>
          {item.status === 'Draft' && <button onClick={() => navigate(`/procurement-plan/${item.id}/edit`)} className="text-amber-600 hover:text-amber-900 flex items-center text-sm font-medium" data-id="element-515">
              <PencilIcon className="h-4 w-4 mr-1" data-id="element-516" /> Edit
            </button>}
        </div>
  }];
  return <div className="space-y-6 h-full flex flex-col pb-8" data-id="element-517">
      <div className="flex items-center justify-between" data-id="element-518">
        <div data-id="element-519">
          <h1 className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-520">
            Annual Procurement Plan
          </h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-521">
            Manage fiscal year procurement plans
          </p>
        </div>
        <button onClick={() => navigate('/procurement-plan/create')} className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 transition-colors" data-id="element-522">
          <PlusIcon className="h-4 w-4 mr-2" data-id="element-523" />
          Create New Plan
        </button>
      </div>

      <div className="flex-1 bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden flex flex-col" data-id="element-524">
        <div className="flex-1 p-0" data-id="element-525">
          <DataTable columns={columns} data={mockPlans} keyExtractor={item => item.id} searchPlaceholder="Search plans..." data-id="element-526" />
        </div>
      </div>
    </div>;
}